module.exports = __webpack_public_path__ + "img/house3.f1057868.png";